/* tslint:disable */
/* eslint-disable */
/**
 * Marco Email Parser API
 * Marco Email Parser API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CapturePaymentRequest
 */
export interface CapturePaymentRequest {
    /**
     * Stripe PaymentIntent id (`pi_xxx`) to capture.
     * @type {string}
     * @memberof CapturePaymentRequest
     */
    paymentIntentId: string;
    /**
     * Stripe Idempotency-Key. Reuse the same key across capture retries for a given booking.
     * @type {string}
     * @memberof CapturePaymentRequest
     */
    idempotencyKey: string;
    /**
     * Optional amount to capture in minor units. Omit to capture the full authorized amount.
     * @type {number}
     * @memberof CapturePaymentRequest
     */
    amountCents?: number | null;
    /**
     * Optional Gondola booking id — attached to logs for traceability.
     * @type {string}
     * @memberof CapturePaymentRequest
     */
    bookingId?: string | null;
    /**
     * Route to STRIPE_SECRET_KEY_TEST instead of the live key.
     * @type {boolean}
     * @memberof CapturePaymentRequest
     */
    test?: boolean;
}

/**
 * Check if a given object implements the CapturePaymentRequest interface.
 */
export function instanceOfCapturePaymentRequest(value: object): value is CapturePaymentRequest {
    if (!('paymentIntentId' in value) || value['paymentIntentId'] === undefined) return false;
    if (!('idempotencyKey' in value) || value['idempotencyKey'] === undefined) return false;
    return true;
}

export function CapturePaymentRequestFromJSON(json: any): CapturePaymentRequest {
    return CapturePaymentRequestFromJSONTyped(json, false);
}

export function CapturePaymentRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): CapturePaymentRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'paymentIntentId': json['payment_intent_id'],
        'idempotencyKey': json['idempotency_key'],
        'amountCents': json['amount_cents'] == null ? undefined : json['amount_cents'],
        'bookingId': json['booking_id'] == null ? undefined : json['booking_id'],
        'test': json['test'] == null ? undefined : json['test'],
    };
}

export function CapturePaymentRequestToJSON(json: any): CapturePaymentRequest {
    return CapturePaymentRequestToJSONTyped(json, false);
}

export function CapturePaymentRequestToJSONTyped(value?: CapturePaymentRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'payment_intent_id': value['paymentIntentId'],
        'idempotency_key': value['idempotencyKey'],
        'amount_cents': value['amountCents'],
        'booking_id': value['bookingId'],
        'test': value['test'],
    };
}

